import { asCurrency, getAmortizationByYear, getInvestmentByYear } from '../util'

export function InvestmentScheduleTable({ investment, groupByCalendarYear = true }) {
  const schedule = getInvestmentByYear(investment, groupByCalendarYear)

  return (
    <>
      {schedule.map((year, index) => (
        <table key={year.label} className="calc-table">
          <thead>
            <tr>
              <th className="md:w-1/6">Event</th>
              <th className="md:w-1/6">Date</th>
              <th className="md:w-1/6">Deposit</th>
              <th className="md:w-1/6">Interest</th>
              <th className="md:w-1/6">Net Change</th>
              <th className="md:w-1/6">Balance</th>
            </tr>
          </thead>
          <tbody>
            {year.events.map((event) => (
              <tr key={event.eventNum}>
                <td>{event.eventNum}</td>
                <td>{event.formattedDate}</td>
                <td>{asCurrency(event.deposit)}</td>
                <td>{asCurrency(event.interest)}</td>
                <td>{asCurrency(event.netChange)}</td>
                <td>{asCurrency(event.balance)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="font-bold text-center bg-gray-100">
              <td colSpan="2">Annual Total</td>
              <td>{asCurrency(year.totals.deposit)}</td>
              <td>{asCurrency(year.totals.interest)}</td>
              <td>{asCurrency(year.totals.netChange)}</td>
              <td>{asCurrency(year.totals.balance)}</td>
            </tr>

            {index === schedule.length - 1 && (
              <tr className="font-bold text-center bg-gray-100 border-t border-black">
                <td colSpan="2">Grand Total</td>
                <td>{asCurrency(investment.totalDeposit)}</td>
                <td>{asCurrency(investment.totalInterest)}</td>
                <td>{asCurrency(investment.totalNetChange)}</td>
                <td>{asCurrency(investment.totalBalance)}</td>
              </tr>
            )}
          </tfoot>
        </table>
      ))}
    </>
  )
}

export function AmortizationScheduleTable({ amortization }) {
  const schedule = getAmortizationByYear(amortization)

  return (
    <>
      {schedule.map((year, index) => (
        <table key={year.label} className="calc-table">
          <thead>
            <tr>
              <th className="md:w-1/6">Event</th>
              <th className="md:w-1/6">Date</th>
              <th className="md:w-1/6">Payment</th>
              <th className="md:w-1/6">Interest</th>
              <th className="md:w-1/6">Principal</th>
              <th className="md:w-1/6">Balance</th>
            </tr>
          </thead>
          <tbody>
            {year.events.map((event) => (
              <tr key={event.eventNum}>
                <td>{event.eventNum}</td>
                <td>{event.formattedDate}</td>
                <td>{asCurrency(event.payment)}</td>
                <td>{asCurrency(event.interest)}</td>
                <td>{asCurrency(event.principal)}</td>
                <td>{asCurrency(event.balance)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="font-bold text-center bg-gray-100">
              <td colSpan="2">Year {year.label} Total</td>
              <td>{asCurrency(year.totals.payment)}</td>
              <td>{asCurrency(year.totals.interest)}</td>
              <td>{asCurrency(year.totals.principal)}</td>
              <td></td>
            </tr>

            {index === schedule.length - 1 && (
              <tr className="font-bold text-center bg-gray-100 border-t border-black">
                <td colSpan="2">Grand Total</td>
                <td>{asCurrency(amortization.totalPayment)}</td>
                <td>{asCurrency(amortization.totalInterest)}</td>
                <td>{asCurrency(amortization.totalPrincipal)}</td>
                <td></td>
              </tr>
            )}
          </tfoot>
        </table>
      ))}
    </>
  )
}

export function InflationScheduleTable({ inflation, type = 'increase' }) {
  const schedule = inflation.schedule

  return (
    <table className="calc-table">
      <thead>
        <tr>
          <th>Year</th>
          <th>{type === 'increase' ? 'Increase' : 'Decrease'} in Cost</th>
          <th>Cost</th>
        </tr>
      </thead>
      <tbody>
        {schedule.map((event) => (
          <tr key={event.eventNum}>
            <td>{event.eventNum}</td>
            <td>{asCurrency(event.diffValue)}</td>
            <td>{asCurrency(event.value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}
